<template>
 <div>
  <label for = "mer-tipo-material-select" class="form-label">Tipo de Material:</label>
  <MultiSelect
   v-model = "selectedObjeto"
   :options = "objeto"
   :disabled="disabled"
   mode = "single"
   :searchable = "true"
   :close-on-select="true"
   valueProp = "valor"
   trackBy = "texto"
   label = "texto"
   placeHolder = "Selecione um Tipo de Material"
   id="mer-tipo-material-select"
  />
 </div>
</template>

<script lang = "ts">
 import { defineComponent, ref, onMounted, watch } from "vue";
 import servico from "@/services/merenda/mertipomaterial/mertipomaterial.service";
 import TextoValor from "@/models/texto-valor";

 export default defineComponent({
  name: "DropDownListMerTipoMaterial",
  props: {
   modelValue: {
    type: Number,
    default: null,
   },
   merClassificacaoId: {
    type: Number,
    default: null,
   },
   disabled: {
    type: Boolean,
    default: false,
   },
  },
  emits:["update:modelValue"],
  setup(props, { emit }) {
   const objeto = ref < TextoValor[]>([]);
   const selectedObjeto = ref < Number | null>(props.modelValue);
   const loading = ref(false);
   const fetchObjeto = async() => {
    loading.value = true;
    try {
     const result = await servico.DropDownList(props.merClassificacaoId);
     objeto.value = result.map((item) => ({
      valor: item.valor,
      texto: item.texto,
     }));
     if (!objeto.value.some((item) => item.valor === props.modelValue)) {
      selectedObjeto.value = null;
     }
    } catch (err) {
     console.error("Erro ao carregar Tipo de Material:", err);
    } finally {
     loading.value = false;
    }
   };

   watch(
    () => props.modelValue,
    (newValue) => {
     selectedObjeto.value = newValue;
    },
    {immediate: true }
   );

   watch(
    () => props.merClassificacaoId,
    () => fetchObjeto()
   );

   watch(selectedObjeto, (newValue) => {
    emit("update:modelValue", newValue);
   });

   onMounted(fetchObjeto);
   return {
    objeto,
    selectedObjeto,
    loading,
   };
  },
 });
</script>
